import {
  ExtranetFaqCategoryDto,
  GetExtranetFaqCategoryQueryDto,
} from '@pharmac-extranet/extranet-api'
import { useQuery } from '@tanstack/react-query'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { getFaqCategoriesQuery } from './faq.queries'

export const useFaqs = (categoryParams?: GetExtranetFaqCategoryQueryDto) => {
  const { i18n } = useTranslation()
  const { data: faqCategoryData, isLoading } = useQuery(
    getFaqCategoriesQuery({ ...categoryParams, lang: i18n.language })
  )

  const [faqCategories, setFaqCategories] = useState<ExtranetFaqCategoryDto[]>([])

  useEffect(() => {
    if (faqCategoryData && !isLoading) {
      setFaqCategories(faqCategoryData)
    }
  }, [faqCategoryData, isLoading])

  return {
    faqCategories,
    setFaqCategories,
    isLoading,
  }
}
